import { AppConfig } from '@chr/online-shared-microsite-core';
import { datadogRum } from '@datadog/browser-rum';

export function initializeDatadog(appConfig: Pick<AppConfig, 'environment'>) {
  try {
    const environment = appConfig.environment;
    if (environment && environment !== 'local') {
      datadogRum.init({
        applicationId: 'bc160d93-5b4f-44bd-9453-3e18dd993681',
        clientToken: 'pub1a40b2d850bedeeddbd83c9106359cfe',
        site: 'us3.datadoghq.com',
        service: 'Online.NotificationSettings.UI',
        env: environment,
        version: '1.0.0',
        sampleRate: 50,
        premiumSampleRate: 10,
        trackInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        useSecureSessionCookie: true,
        allowedTracingOrigins: [/https:\/\/.*\.chrobinson\.com/],
        beforeSend: event => {
          event.view.url = event.view.url.toLowerCase().replace('#/', '');
        },
      });
    }
  } catch {
    // Do not block loading for a datadog error
  }
  datadogRum.startSessionReplayRecording();
}

export function setDatadogUser(userId?: string) {
  try {
    if(userId) {
      datadogRum.setUser({
        id: userId
      });
    }
  } catch(error) {
    // Do not block loading for a datadog error
  }
}
